import { action, computed, observable, runInAction } from "mobx";
import { api } from "../../api";
import {
  IContestacaoCalc,
  IEmpresa,
  IIcmsClassificacao,
  IImportInfo,
  INaoContestadosFilters,
  IResultadoItem,
  IResultadoItemProdutos,
  IResultadoSummary,
  IResultadosFilters,
  newEmpresa,
  newIImportInfo,
  newINaoContestadosFilters,
  newIResultadosFilters,
} from "../../model";
import { toast } from "react-toastify";
import { decodeUtf8String, downloadBinaryFile, sortBy } from "../../utils";
import { AppStore } from "../AppStore";
import { NotasStore } from "../notas/NotasStore";

export class _ResultadoStore {
  obs = observable({
    current_page: 1 as number,
    loading: false as boolean,
    results: [] as IResultadoItem[],
    icmsClassFilter: null as IIcmsClassificacao,
    icmsNomeSelect: "" as string,
    filter: "" as string,
    filters_nao_contestados: newINaoContestadosFilters() as INaoContestadosFilters,
    text: "" as string,
    itemsCount: 0 as number,
    itemsAllCount: 1 as number,
    count: 10 as number,
    summaryCount: 0 as number,
    summary: [] as IResultadoSummary[],
    all_summary: [] as IResultadoSummary[],
    empresas: [] as IEmpresa[],
    filterErrors: false as boolean,
    working: false as boolean,
    contestar_todos: false as boolean,
    ids_contestacao_all: [] as any,
    notasRetroativas: false as boolean,
    notasDivergentes: false as boolean,
    notasManual: false as boolean,
    result_memoria: [] as IResultadoItemProdutos[],
    pageProduto: 1 as number,
    result_memoria_count: 0 as number,
    contestarItems: [] as any[],
    openContestacaoLote: false as boolean,
    openContestacaoSuregidos: false as boolean,
    loading_suregidos: false as boolean,
    tasks_contestacao: [] as any[],
    length_tasks_contestacao: 0 as number,
    itens_processando: [] as string[],
    contestacao_summary: newIImportInfo() as IImportInfo,
    isValida: false as boolean,
    erros_contestacao: [] as any[],
    libera_busca: true as boolean,
    modelo: "NF-E" as string,
    tipo: "Entrada" as string,
    openContestacaoLoteCalculados: false as boolean,
    selectedTab: "summary" as string,
    nao_calculados: false as boolean,
    empresaContestar: newEmpresa() as IEmpresa,
    estado: "" as string,
    filter_produtos: "" as string,
    page_produto_rs: 1 as number,
    nao_calculados_rs: false as boolean,
    result_memoria_rs_count: 0 as number,
    result_memoria_rs: [] as IResultadoItemProdutos[],
    date_start: "" as string,
    date_referencia: "" as string,
    date_end: "" as string,
    selectedResultadosTab: "result_calc" as string,
    filters: newIResultadosFilters() as IResultadosFilters,
    progressSendEmail: false,
    sefa: false,
    tasks_relatorio: [],
    page_tasks_relatorio: 1 as number,
    length_tasks_relatorio: 0 as number,
    loading_solicitacao: false as boolean,
    loading_download: false as boolean,
    loading_rastreamento: false as boolean,
    itens: [] as any[],
    nota_vars: [] as any[],
    calc_vars: [] as any[],
    nota_vars_fcp: [] as any[],
    calc_vars_fcp: [] as any[],
    descritivo_calc: "" as string
  })

  setIcmsClassFilter(ic: IIcmsClassificacao) {
    if (ic.nome == "Todas" || ic.nome == "Sem classificação (itens não calculados)") {
      this.obs.icmsNomeSelect = ic.nome;
    }

    this.obs.icmsClassFilter = ic;
  }

  @action
  setBooleanFiltros(bol: boolean) {
    this.obs.notasRetroativas = bol;
    this.obs.notasDivergentes = bol;
    this.obs.notasManual = bol;
  }

  selectAllContestarLote(modelo, tipo) {

    this.resetContestarItems();

    for (let i = 0; i < this.obs.results.length; i++) {

      let data = {
        id: this.obs.results[i].id.toString(),
        data: this.obs.results[i].data,
      };

      this.obs.contestarItems.push(data);
    }

  }

  @action
  selectAllContestarLoteCTE() {
    this.resetContestarItems();
    for (let i = 0; i < this.obs.results.length; i++) {
      let data = {
        id: this.obs.results[i]._id.toString(),
        data: this.obs.results[i].data,
      };
      this.obs.contestarItems.push(data);
    }
  }

  @action
  selectAllContestarLoteNaoCalculados() {
    this.resetContestarItems();
    for (let i = 0; i < this.obs.result_memoria.length; i++) {
      let data = {
        id: this.obs.result_memoria[i]._id.toString(),
        data: this.obs.result_memoria[i].data,
        calcs: this.obs.result_memoria[i].calcs,
        produtos: this.obs.result_memoria[i].produtos,
      };
      this.obs.contestarItems.push(data);
    }
  }

  @computed
  get allSelected(): boolean {
    if (this.obs.results.length == 0) return false;

    for (let i = 0; i < this.obs.results.length; i++) {
      if (!this.obs.results[i]._selected) return false;
    }
    return true;
  }

  @action
  clearAllData() {
    this.obs.results = [];
    this.obs.itemsCount = 0;
    this.obs.summary = [];
  }

  @computed
  get selectedResults(): IResultadoItem[] {
    let ret = [];
    for (let i = 0; i < this.obs.results.length; i++) {
      if (this.obs.results[i]._selected) ret.push(this.obs.results[i]);
    }
    return ret;
  }

  @action
  setContestarItems(items: IContestacaoCalc) {
    this.obs.contestarItems.push(items);
  }

  @action
  setContestarItemsList(items: IContestacaoCalc[]) {
    this.obs.contestarItems = items;
  }
  @action
  setContestarItemsListNao(items) {
    this.obs.contestarItems = items;
  }

  resetContestarItems() {

    this.obs.contestar_todos = false;

    this.obs.contestarItems = [];

  }

  @action
  deleteByIdContestarItems(id: string) {
    ResultadoStore.obs.contestar_todos = false;
    this.obs.contestarItems = this.obs.contestarItems.filter(
      (value) => value["id"] != id
    );
  }

  @computed
  get selectedCount(): number {
    return this.obs.contestarItems.length;
  }

  @action
  handleUpdate = (item: IResultadoItem) => {
    runInAction(() => {
      let idx = this.obs.results.findIndex((x) => x.id == item.id);
      if (idx != -1) {
        this.obs.results.splice(idx, 1, item);
      }
    });
  };

  @action
  async loadEmpresas(): Promise<void> {
    try {
      let resp = await api.get(`/api/empresas-usuario`);

      this.obs.empresas = [];
      this.obs.empresas = resp.data

    } catch (ex) {
      toast.error(`Erro ao carregar Empresas Usuário, tente novamente mais tarde.`, {});
    }
  }

  @action
  async download_xml(chave: any, entrada_saida: string, modelo: string, dhemi: string, cnpj: string): Promise<void> {

    try {
      let data = { chave: chave, entrada_saida: entrada_saida, modelo: modelo, dhemi: dhemi, cnpj: cnpj };
      let resp = await api.post(`/api/requisicao-download-xml`, data);
      runInAction(() => {
        if (!resp.data.ok) {
          toast.error('Não foi possível realizar o download.', {});
        } else {
          const linkSource = `data:application/xml;base64,${resp.data.base64}`;
          const downloadLink = document.createElement("a");
          downloadLink.href = linkSource;
          downloadLink.download = `${chave}.xml`;
          downloadLink.click();
        }
      });
    } catch (ex) {
      toast.error(`Erro ao realizar Download Xml, tente novamente mais tarde.`, {});
    }
  }

  @computed
  get sortedEmpresas(): IEmpresa[] {
    return sortBy(this.obs.empresas, "razao_social");
  }

  async query() {

    let empresa: IEmpresa = AppStore.obs1.selectedEmpresa
    let period: any = [ResultadoStore.obs.date_start, ResultadoStore.obs.date_end]
    let icmsClassificacao: IIcmsClassificacao = ResultadoStore.obs.icmsClassFilter
    let tipo: string = ResultadoStore.obs.tipo
    let page: number = ResultadoStore.obs.current_page
    let modelo: string = ResultadoStore.obs.modelo
    let filters: any = ResultadoStore.obs.filters

    this.resetContestarItems();
    this.handldeItensProcessando();

    this.obs.filterErrors = false;
    this.obs.loading = true;

    let icms_class_id = this.getIcmsClassId(icmsClassificacao);

    this.obs.empresaContestar = empresa

    let params = {
      period: period,
      empresa: empresa && empresa.cnpj,
      icms_classificacao_id: icms_class_id,
      tipo: tipo,
      page: page,
      modelo: modelo,
      page_size: 15,
      filters: filters
    };

    try {

      let resp;
      let niveis_acesso = AppStore.obs1.usuario ? AppStore.obs1.usuario.niveis_acesso : [""];

      if (niveis_acesso.indexOf("c1") != -1) {

        if (modelo == "CT-E") {

          resp = await api.post("/api/resultados/paged-cte", { params: params });

        } else {

          resp = await api.post("/api/resultados/paged", { params: params });

        }

        if (resp.data.ok) {
          this.obs.itemsCount = resp.data.items.length;
          // this.obs.summaryCount = resp.data.total_summary;
          this.obs.summary = resp.data.summary;
          this.obs.all_summary = resp.data.all;

          this.obs.results = [];
          this.obs.results = resp.data.items

          this.obs.sefa = resp.data.sefa

        }
      }

    } catch (ex) {
      toast.error(`Erro ao consultar Resultados de Cálculos, tente novamente mais tarde.`, {});
    }

    this.obs.loading = false;
  }

  async query_all_itens_pages(empresa: IEmpresa, period: any, icmsClassificacao: IIcmsClassificacao, tipo: string, modelo: string, filters: any) {

    let page = 1;
    const page_size = 500000;

    let icms_class_id = this.getIcmsClassId(icmsClassificacao);

    while (true) {

      try {

        const params = {
          period,
          empresa: empresa?.cnpj,
          icms_classificacao_id: icms_class_id,
          tipo,
          page,
          modelo,
          page_size,
          filters
        };

        const endpoint = modelo === "CT-E" ? "/api/resultados/paged-cte" : "/api/resultados/paged";
        const resp = await api.post(endpoint, { params });

        if (!resp.data || !resp.data.items || resp.data.items.length === 0) {
          break;
        }

        const novosIds = resp.data.items
          .map((item: any) => item.id || item._id)
          .filter((id: string) => !this.obs.itens_processando.includes(id));

        this.obs.ids_contestacao_all.push(...novosIds);

        page++;

      } catch (error) {

        toast.error("Erro ao consultar todos Resultados de Cálculos, tente novamente mais tarde.");

      }

    }

  }

  async handleIsContestados(estado: string) {

    try {

      let data = {
        estado: estado
      };

      let resp = await api.post("/api/empresas-contestacao-produto-count", data);

      if (resp.data.total > 0) {

        this.obs.nao_calculados = true

      } else {

        this.obs.nao_calculados = false

      }

    } catch (ex) {

      toast.error(`Erro ao consultar total filtrado Não Contestados, tente novamente mais tarde.`, {});

    }

  }

  @action
  async handleResultMemoriaFiltered(page: number, estado: string) {
    try {
      let data = {
        page: page,
        limit: 15,
        filters: this.obs.filters_nao_contestados,
        estado: estado
      };

      let resp = await api.post("/api/empresas-contestacao-produto-filtered", data);

      this.obs.result_memoria = [];
      this.obs.result_memoria_count = 0;

      if (resp.data.itens.length != 0) {
        this.obs.result_memoria = resp.data.itens
        this.obs.result_memoria_count = resp.data.count

      }

    } catch (ex) {
      toast.error(`Erro ao consultar filtro Não Contestados, tente novamente mais tarde. `, {});
    }
  }

  @action
  async handleResultMemoriaFilteredAll(estado: string) {

    let page = 1;
    const limit = 500;

    while (true) {

      try {

        const data = {
          page,
          limit,
          filters: this.obs.filters_nao_contestados,
          estado
        };

        const resp = await api.post("/api/empresas-contestacao-produto-filtered", data);

        if (!resp.data || !resp.data.itens || resp.data.itens.length === 0) {
          break;
        }

        resp.data.itens.forEach((item: any) => {

          const id = item._id || item.id;

          if (!this.obs.itens_processando.includes(id)) {

            this.obs.ids_contestacao_all.push({
              id,
              data: item.data,
              entrada_saida: item.entrada_saida,
              cnpj_destino: item.cnpj_destino,
              cnpj_origem: item.cnpj_origem
            });

          }

        });

        page++;

      } catch (ex) {

        toast.error(`Erro ao consultar todos filtrados Não Contestados, tente novamente mais tarde.`, {});

      }

    }

  }

  async export(params): Promise<void> {

    this.obs.loading_solicitacao = true

    try {

      let resp = await api.post("/api/resultados/export/create", params);

      if (resp.data.ok) {

        toast.success(`Solicitação realizada com sucesso.`, {});

      } else {

        toast.error(resp.data.erro, {});

      }

    } catch (ex) {

      toast.error(`Erro ao exportar arquivo, tente novamente mais tarde.`, {});

    }

    this.obs.loading_solicitacao = false

  }

  async create_contestacao_task(contestacao: any, memoria: boolean, estado: string, devolucao: boolean, cnpj: string, periodo_inicial: string, periodo_final: string, cnpj_memoria: boolean) {

    try {

      const data = {
        data: contestacao,
        memoria_contestacao: memoria,
        estado: estado.toLowerCase(),
        devolucao: devolucao,
        periodo_inicial: periodo_inicial,
        periodo_final: periodo_final,
        cnpj: cnpj,
        cnpj_memoria: cnpj_memoria
      }

      let resp = await api.post("/api/create-contestacao-task", data);

      if (resp.data.ok) {

        toast.success("Contestações Cadastradas", {});

      } else {

        toast.error(resp.data.erro, {});

      }

    } catch (ex) {

      toast.error("Erro ao criar Task Lote Contestação, tente novamente mais tarde.", {});

    }

    this.obs.working = false

  }

  async consulta_resultados_calculo() {

    await new Promise(resolve => setTimeout(resolve, 5000));

    this.handleConsultaProdutos()

    if (NotasStore.obs.empresasAtrasadasManual.length > 0) {

      NotasStore.loadAtrasadasManual();

    }

    await this.query()

  }

  async handleConsultaTodas(paged: number, limit: number) {
    try {
      let data = {
        paged: paged,
        limit: limit
      }
      let resp = await api.post("/api/index-contestacao-task", data);

      this.obs.length_tasks_contestacao = 0
      this.obs.tasks_contestacao = []

      if (resp.data.itens.length > 0) {

        this.obs.tasks_contestacao = resp.data.itens
        this.obs.length_tasks_contestacao = resp.data.count
      }

    } catch (ex) {
      toast.error("Erro ao consultar Tasks Contestações, tente novamente mais tarde.", {});
    }
  }

  async handldeItensProcessando() {
    try {
      let resp = await api.get("/api/index-contestacao-task-pendentes");
      this.obs.itens_processando = []
      this.obs.itens_processando = resp.data.items

    } catch (ex) {
      toast.error("Erro ao consultar Itens Processando, tente novamente mais tarde.", {});
    }
  }

  async summary_contestacao(importacao_id: string, tipo: string, modelo: string) {
    try {
      this.obs.isValida = false;
      this.obs.contestacao_summary = newIImportInfo();

      let data = {
        contestacao_id: importacao_id,
        tipo: tipo,
        modelo: modelo
      }

      let resp = await api.post(`/api/import/summary`, data);

      runInAction(() => {
        if (Array.isArray(resp.data)) {
          this.obs.isValida = true
        } else {
          this.obs.isValida = false;
          this.obs.contestacao_summary = resp.data
        }
      });
    } catch (ex) {
      toast.error("Erro ao consultar Task Summary Contestações, tente novamente mais tarde.", {});
    }
  }

  async busca_erros_contestacao(contestacao_id) {
    try {
      this.obs.erros_contestacao = []

      let data = { contestacao_id: contestacao_id, }

      let resp = await api.post(`/api/import/erros`, data);

      runInAction(() => {
        if (resp.data.length > 0) {
          resp.data?.map(values => {
            values.itens?.map(erros => {
              this.obs.erros_contestacao.push(erros);
            })
          })
        } else {
          this.obs.erros_contestacao = []
        }
      });
    } catch (ex) {
      toast.error("Erro ao consultar Task Erros Contestações, tente novamente mais tarde.", {});
    }
  }

  @action
  selectAllContestarLoteRsNaoCalculados() {
    this.resetContestarItems();
    for (let i = 0; i < this.obs.result_memoria_rs.length; i++) {
      let data = {
        id: this.obs.result_memoria_rs[i]._id.toString(),
        data: this.obs.result_memoria_rs[i].data,
        calcs: this.obs.result_memoria_rs[i].calcs,
        produtos: this.obs.result_memoria_rs[i].produtos,
      };
      this.obs.contestarItems.push(data);
    }
  }

  async handleIsContestadosRs(estado: string) {
    try {
      let data = {
        estado: estado,
      };

      let resp = await api.post("/api/empresas-contestacao-produto-count", data);

      if (resp.data.total > 0) {
        this.obs.nao_calculados_rs = true
      } else {
        this.obs.nao_calculados_rs = false
      }
    } catch (ex) {
      toast.error(`Erro ao consultar total filtrado Não Contestados, tente novamente mais tarde. `, {});
    }
  }

  @action
  async handleResultMemoriaRsFiltered(page: number, estado: string) {
    try {
      let data = {
        page: page,
        limit: 15,
        filters: this.obs.filters_nao_contestados,
        estado: estado,
      };

      let resp = await api.post("/api/empresas-contestacao-produto-filtered", data);

      this.obs.result_memoria_rs = [];
      this.obs.result_memoria_rs_count = 0

      if (resp.data.itenslength > 0) {
        this.obs.result_memoria_rs = resp.data.itens
        this.obs.result_memoria_rs_count = resp.data.count;
      }

    } catch (ex) {
      toast.error(`Erro ao consultar filtro Não Contestados, tente novamente mais tarde.`, {});
    }
  }

  async handleConsultaProdutos() {
    this.obs.pageProduto = 1;

    await ResultadoStore.handleResultMemoriaFiltered(1, "PA");
    await ResultadoStore.handleIsContestados("PA");

    await ResultadoStore.handleResultMemoriaRsFiltered(1, "RS");
    await ResultadoStore.handleIsContestadosRs("RS");
  }

  async queryCalcSugeridos(empresa: IEmpresa, period: any, icmsClassificacao: IIcmsClassificacao, tipo: string, modelo: string, filters: any) {

    this.obs.loading_suregidos = true

    let itens: any = []

    let icms_class_id = this.getIcmsClassId(icmsClassificacao);

    try {

      for (let i = 1; this.obs.itemsAllCount > 0; i++) {

        let params = {
          period: period,
          empresa: empresa && empresa.cnpj,
          icms_classificacao_id: icms_class_id,
          tipo: tipo,
          page: i,
          modelo: modelo,
          page_size: 500,
          filters: filters
        };

        let resp: any = []

        if (modelo == 'CT-E') {

          resp = await api.post("/api/resultados/paged-cte", { params: params });

        } else {

          resp = await api.post("/api/resultados/paged", { params: params });

        }

        this.obs.itemsAllCount = resp.data.items.length;

        for (let i = 0; i < resp.data.items.length; i++) {

          const item = resp.data.items[i];
          const id = item.id || item._id;

          const notProcessing = !ResultadoStore.obs.itens_processando.includes(id);
          const hasCalcSugerido = item.calc_sugerido && item.calc_sugerido_id;
          const hasSugeridoList = Array.isArray(item.sugerido_list) && item.sugerido_list.length === 1;

          if (notProcessing && (hasCalcSugerido || hasSugeridoList)) {
            itens.push(item);
          }

        }

      }

      this.obs.ids_contestacao_all = itens.reduce((acc, item) => {

        let key = null;

        if (item.calc_sugerido_id) {

          key = item.calc_sugerido_id;

        } else if (item.sugerido_list && item.sugerido_list.length === 1) {

          key = item.sugerido_list[0].calc_id;

        }

        if (key) {

          if (!acc[key]) {

            acc[key] = [];

          }

          acc[key].push(item.id);

        }

        return acc;

      }, {});

    } catch (ex) { }

    this.obs.loading_suregidos = false

  }

  getIcmsClassId(icmsClassificacao) {

    let todas = this.obs.icmsNomeSelect;

    if (todas == "Todas") {

      return icmsClassificacao && icmsClassificacao.id
        ? icmsClassificacao.id
        : "TODAS";

    } else if (todas == "10") {

      return icmsClassificacao && icmsClassificacao.id
        ? icmsClassificacao.id
        : "10";

    } else if (todas == "Sem classificação (itens não calculados)") {

      return icmsClassificacao && icmsClassificacao.id
        ? icmsClassificacao.id
        : "NONE";

    } else {

      return icmsClassificacao && icmsClassificacao.id
        ? icmsClassificacao.id
        : "TODAS";
    }

  }

  async loadProdutos(page: number, ncm: string, cest: string, entrada_saida: string, estado: string) {

    let data = {
      page: page,
      limit: 50,
      ncm: (ncm || "").replace(/\./g, ""),
      cest: (cest || "").replace(/\./g, ""),
      entrada_saida: entrada_saida.toLowerCase().replace("í", "i"),
      estado: estado
    }

    let resp = await api.post("/api/produtos-filter", data)

    if (resp.data.itens.length > 0) {

      return resp.data.itens

    }

    return []

  }

  /**
 * Realiza o download do DANFE (Documento Auxiliar da Nota Fiscal Eletrônica) em formato PDF.
 * 
 * Este método faz uma requisição à API para gerar o DANFE em formato base64 e, em seguida, cria um link de download
 * para o usuário baixar o arquivo PDF. Se houver erro na requisição ou no processo de download, uma mensagem de erro é exibida.
 *
 * @param {Object} data - Os dados necessários para gerar o DANFE. Este objeto pode incluir informações como o número da NFe, série, etc.
 * @param {string} chave - A chave da Nota Fiscal Eletrônica (NFe) utilizada para nomear o arquivo PDF. 
 * @returns {Promise<void>} - Retorna uma promessa que resolve quando o processo de download for completado ou se ocorrer um erro.
 *
 */
  async view_danfe(data: any, chave: string) {

    try {

      let resp = await api.post("/api/danfe-download", data);

      if (resp.status == 200) {

        let linkSource = `data:application/pdf;base64,${resp.data.base64}`
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = `${chave}.pdf`;
        downloadLink.click();

      } else {

        toast.error(decodeUtf8String(resp.headers.msg), {});

      }

    } catch (ex) {

      toast.error(`Erro ao realizar Download Danfe, tente novamente mais tarde.`, {});

    }

  }

  async handleTasksPaged(paged: number) {
    try {
      const selectedEmpresa = AppStore.obs1.selectedEmpresa;

      let data: any = {
        page: paged,
        limit: 15
      };

      if (selectedEmpresa && selectedEmpresa.cnpj) {
        data.cnpj = selectedEmpresa.cnpj;
      }

      let resp = await api.post("/api/resultados/export/index", data);

      this.obs.tasks_relatorio = [];
      this.obs.length_tasks_relatorio = 0;

      if (resp.data.itens.length > 0) {
        this.obs.tasks_relatorio = resp.data.itens;
        this.obs.length_tasks_relatorio = resp.data.count;
      }

    } catch (ex) {
      toast.error("Erro ao Carregar Relatórios Solicitados, tente novamente mais tarde.", {});
    }
  }

  async handleDownloadArquivoRelatorio(id: string, cnpj: string) {

    this.obs.loading_download = true

    try {

      let resp = await api.post(`/api/relatorio/task/download`, {id: id, format: "xlsx"}, { responseType: 'blob' });

      if(resp.status == 200){

        const fileName = cnpj + "_relatorio.xlsx";

        downloadBinaryFile(resp.data, fileName)

      } else {

        toast.error(decodeUtf8String(resp.headers.msg), {});

      }

    } catch (ex) {

      toast.error('erro ao baixar o arquivo, tente novamente mais tarde ou contate o suporte.', {});

    }

    this.obs.loading_download = false

  }

  /**
 * Realiza a busca de itens de Nota Fiscal (NF) a partir de uma chave de acesso informada.
 * 
 * Este método valida a chave de acesso (deve conter exatamente 44 caracteres),
 * envia os filtros de `modelo` e `tipo` junto à chave para a API, 
 * e atualiza a lista de itens (`this.obs.itens`) com os resultados obtidos.
 * 
 * Fluxo:
 *  1. Recupera e limpa a chave informada no filtro (`this.obs.filter`).
 *  2. Valida se a chave possui exatamente 44 caracteres.
 *  3. Monta o objeto de parâmetros com `modelo`, `tipo` e `chave`.
 *  4. Define `loading_rastreamento` como `true` para indicar carregamento.
 *  5. Realiza requisição POST para `/api/resultados/rastreamento`.
 *  6. Atualiza `this.obs.itens` com os resultados retornados pela API.
 *     - Se não houver resultados, exibe um aviso via `toast.warning`.
 *  7. Em caso de erro, exibe no console e mantém feedback visual de erro para o usuário.
 *  8. Finaliza carregamento (`loading_rastreamento = false`).
 *
 * @async
 * @function buscarItens
 * @returns {Promise<void>} Retorna uma Promise que é resolvida quando a busca é concluída.
 */

  buscarItens = async () => {
    try {
      const chave = (this.obs.filter || "").trim();
    
      const modelo = this.obs.modelo;

      if ((modelo === "NFS-E" && chave.length !== 50) || (modelo !== "NFS-E" && chave.length !== 44)) {
        toast.warning("Chave inválida!");
        return;
      }

      const tipo = this.obs.tipo;

      const params = {
        modelo: modelo,
        tipo: tipo,
        chave: chave
      }

      this.obs.loading_rastreamento = true;

      let resp = await api.post(`/api/resultados/rastreamento`, params);
      
      this.obs.itens = []

      if (resp.data.length) {
        this.obs.itens = resp.data;
      } else{
        toast.warning("Nenhum item encontrado para a chave informada.");
      }

    } catch (error) {
      console.error("Erro ao buscar itens:", error);
    }
    this.obs.loading_rastreamento = false;
  };

  async loadDetalhamentoCalculo(calc_id: string) {

    try {

      let resp = await api.post("/api/notas/item/calc", {calc_id: calc_id});

      this.obs.nota_vars = []
      this.obs.calc_vars = []

      this.obs.nota_vars_fcp = []
      this.obs.calc_vars_fcp = []

      this.obs.descritivo_calc = ""

      if(resp.status === 200) {

        this.obs.nota_vars = resp.data.nota_vars
        this.obs.calc_vars = resp.data.calc_vars

        this.obs.nota_vars_fcp = resp.data.nota_vars_fcp
        this.obs.calc_vars_fcp = resp.data.calc_vars_fcp

        this.obs.descritivo_calc = resp.data.descritivo

      }

    } catch (ex) {}

  }

  async handleMvas(page: number, filter: string, tipo: string, estado: string) {

    try {

      let data = {
        page: page,
        limit: 20,
        filter: filter.replace(/\./g, ""),
        vigencia: true,
        entrada: tipo.toLowerCase().replace("í", "i") == "entrada" ? true : false
      }

      let router = "/api/mvas/index"

      if(estado == "RS") router = "/api/mvas/rs/index"

      let resp = await api.post(router, data);

      if (resp.data.itens.length > 0) {

        return resp.data.itens

      }

    } catch (ex) {}

    return []

  }

}

export const ResultadoStore = new _ResultadoStore();
